import * as Yup from 'yup'
import { DateRange } from '../pages/type'

const applyTimeoffSchema = (validDateRangeResults: DateRange[]) => {
    const customHoursSchema = validDateRangeResults.reduce(
        (acc, _, index) => {
            acc[`customHours_${index}`] = Yup.number()
                .min(0.1, 'Custom hours must be more than 0')
                .max(8, 'Custom hours must be 8 or less')
            return acc
        },
        {} as Record<string, Yup.Schema<any>>
    )

    return Yup.object().shape({
        leaveTypes: Yup.string().required('Leave type is required'),
        startdate: Yup.string()
            .required('Start date is required')
            .test(
                'is-before-enddate',
                'Start date must be before or equal to end date',
                function (value) {
                    const { enddate } = this.parent
                    return !enddate || new Date(value) <= new Date(enddate)
                }
            ),
        enddate: Yup.string()
            .required('End date is required')
            .test(
                'is-after-startdate',
                'End date must be after or equal to start date',
                function (value) {
                    const { startdate } = this.parent
                    return !startdate || new Date(value) >= new Date(startdate)
                }
            ),
        customHours: Yup.object().shape(customHoursSchema),
        description: Yup.string().required('Notes are required'),
    })
}
export { applyTimeoffSchema }
